import { flow, types } from "mobx-state-tree";
import { ErrorModel } from "../../components/common/error";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import { PaginationModel } from "../share/PagingModel";
import { PlanHeaderModel } from "../share/PlanModel";
import monthlyReportAPI from "./MonthlyReportService";

export const MonthlyReportListModel = types
  .model("MonthlyReportListModel", {
    startYear: customtypes.optional(types.string, ""),
    planRelease: customtypes.optional(types.string, ""),
    planID: customtypes.optional(types.string, ""),
    projectType: customtypes.optional(types.string, ""),
    list: customtypes.optional(types.array(PlanHeaderModel), []),
    paging: customtypes.optional(PaginationModel, {}),
    organizationID: types.maybeNull(types.number),
    error: customtypes.optional(ErrorModel, {}),
    loading: types.optional(types.boolean, false),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    getMonthlyReportList: flow(function*() {
      try {
        self.loading = true;

        const result = yield monthlyReportAPI.getMonthlyReportList({
          year: self.startYear,
          planRelease: self.planRelease,
          planID: self.planID,
          projectType: self.projectType,
          organizationID: self.organizationID,
          paging: self.paging,
        });
        self.list = result.data;
        self.setPagination(result);
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    removeMonthlyReport: flow(function*(planID: number) {
      try {
        self.loading = true;
        const result = yield monthlyReportAPI.removeMonthlyReport(planID);
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    onSelectedFilter: (value: any) => {
      self.setDefaultPagination();
      self.planRelease = value;
      self.getMonthlyReportList();
    },
    setPagination: (result: any) => {
      self.paging.pageSize = result.pageSize;
      self.paging.pageNo = result.pageNo;
      self.paging.totalRow = result.totalRow;
    },
    onSelectedPage: (pageNo: number) => {
      self.paging.pageNo = pageNo;
      self.getMonthlyReportList();
    },
    setDefaultPagination: () => {
      self.paging.pageNo = 1;
    },
    resetAll: () => {
      self.list = [];
      self.paging = {};
      self.planRelease = "";
      self.startYear = "";
      self.planID = "";
      self.projectType = "";
      self.organizationID = undefined;
    },
  }));

export type IMonthlyReportListModel = typeof MonthlyReportListModel.Type;
